<template>
    <div :class="{ hidden: hidden }" class="pagination-container">
      <el-pagination
        hide-on-single-page
        v-bind="$attrs"
        :background="background"
        :current-page.sync="currentPage"
        :layout="layout"
        :page-size.sync="limit"
        :page-sizes="pageSizes"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        prev-text="上一页"
        next-text="下一页 "
      />
    </div>
  </template>
  
  <script>
  // 分页组件
  import { scrollTo } from './scroll-to' // 滚动方法
  export default {
    name: 'Pagination',
    props: {
      limit:{
        type: Number,
      },
      total: {
        // 总页数
        required: true,
        type: Number,
      },
      page: {
        // 当前页
        type: Number,
        default: 1,
      },
      pageSize: {
        // 当前页
        type: Number,
        // default: 1,
      },
      pageSizes: {
        // 可选择的每页条数
        type: Array,
        default() {
          return [10, 20, 30, 50]
        },
      },
      layout: {
        // 展示顺序
        type: String,
        default: ' pager,prev, next, jumper',
      },
      background: {
        // 是否有背景
        type: Boolean,
        default: true,
      },
      autoScroll: {
        // 页面是否滚动
        type: Boolean,
        default: true,
      },
      hidden: {
        // 是否隐藏
        type: Boolean,
        default: false,
      },
    },
    created() {
      console.log('zongshu',this.total)
      console.log('page',this.page)
      console.log('limit',this.limit)
      console.log('pageSize',this)
    },
    //   mounted(){
    // // console.log('zongshu',this.total)
    // // console.log('page',this.page)
    //   },
    computed: {
      // 当前页码计算
      currentPage: {
        get() {
          return this.page
        },
        set(val) {
          this.$emit('update:page', val)
        },
      },
      // 当前每页记录
      // pageSize: {
      //   get() {
      //     return this.limit;
  
      //   },
      //   set(val) {
      //     this.$emit("update:limit", val);
      //   },
      // },
    },
    methods: {
      handleSizeChange(val) {
        console.log('dianji',val)
        // 每页显示条数变化方法
        this.currentPage = 1
        this.$emit('pagination', { page: this.currentPage, limit: val })
        if (this.autoScroll) {
          scrollTo(0, 800)
        }
      },
      handleCurrentChange(val) {
        console.log('dianji-----',val)
        // 当前页变化方法
        this.$emit('pagination', { page: val, limit: this.pageSize })
        if (this.autoScroll) {
          scrollTo(0, 1000)
        }
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  /* //分页组件样式 */
  .pagination-container {
    // text-align: right;
    background: #fff;
    padding: 1rem 1rem;
  }
  
  .pagination-container.hidden {
    display: none;
  }
  /deep/ .el-pagination button:disabled {
    box-sizing: border-box;
    border-width: 0.0625rem;
    border-style: solid;
    border-color: rgba(217, 217, 217, 1);
    border-radius: 0.375rem;
    min-width: 2rem;
    height: 2rem;
    margin-left: 0.1875rem;
    margin-right: 0.1875rem;
  }
  
  /deep/ .el-pagination button {
    box-sizing: border-box;
    border-width: 0.0625rem;
    border-style: solid;
    border-color: rgba(217, 217, 217, 1);
    border-radius: 0.375rem;
    min-width: 2rem;
    height: 2rem;
    margin-left: 0.1875rem;
    margin-right: 0.1875rem;
  }
  
  /deep/ .el-pager li {
    min-width: 2rem;
    height: 2rem;
    background: inherit;
    background-color: rgba(255, 255, 255, 1) !important;
    box-sizing: border-box;
    border-width: 0.0625rem;
    border-style: solid;
    border-color: rgba(217, 217, 217, 1);
    border-radius: 0.375rem;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.647058823529412);
    line-height: 1.375rem;
    padding-top: 0.3125rem;
    margin-left: 0.1875rem;
    margin-right: 0.1875rem;
  }
  
  /deep/ .el-pager li.active {
    min-width: 2rem;
    height: 2rem;
    background: inherit;
    background-color: rgba(24, 144, 255, 1) !important;
    border: none;
    border-radius: 0.375rem;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 0.875rem;
    color: #ffffff;
    line-height: 1.375rem;
    padding-top: 0.3125rem;
    margin-left: 0.1875rem;
    margin-right: 0.1875rem;
  }
  /deep/.el-pager .more::before {
    line-height: 1.5625rem;
  }
  
  /deep/ .el-pagination .el-select .el-input .el-input__inner {
    height: 2rem;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 0.0625rem;
    border-style: solid;
    border-color: rgba(217, 217, 217, 1);
    border-radius: 0.375rem;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.647058823529412);
    line-height: 1.375rem;
  }
  
  /deep/ .el-pagination .el-select .el-input.is-focus .el-input__inner {
    font-family: 'Microsoft Tai Le', sans-serif;
    font-style: normal;
    font-size: 0.875rem;
    text-align: center;
    border-color: #1890ff;
  }
  
  /deep/ .el-pagination .el-select .el-input .el-input__inner:hover {
    font-family: 'Microsoft Tai Le', sans-serif;
    font-style: normal;
    font-size: 0.875rem;
    text-align: center;
    border-color: #1890ff;
  }
  
  /deep/ .el-pagination__jump {
    font-weight: normal;
    color: #606266;
  }
  
  /deep/ .el-pagination__editor.el-input .el-input__inner {
    height: 2rem;
    background: inherit;
    background-color: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    border-width: 0.0625rem;
    border-style: solid;
    border-color: rgba(217, 217, 217, 1);
    border-radius: 0.375rem;
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.647058823529412);
    line-height: 1.375rem;
  }
  
  /deep/ .el-table__body tr.current-row > td {
    background-color: #bdd6f3 !important;
  }
  /deep/ .el-pagination.is-background,
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .el-pager li {
    background-color: #ffffff;
    color: #666666;
    border-radius: 0.625rem;
  }
  /deep/ .btn-prev {
    border: 0.0625rem solid #d9d9d9;
    opacity: 1;
    border-radius: 0.25rem;
    padding: 0 0.3125rem !important;
  }
  /deep/ .btn-next {
    background-color: #fff !important;
    border: 0.0625rem solid #d9d9d9;
    opacity: 1;
    border-radius: 0.25rem;
    padding: 0 0.3125rem !important;
  }
  
  /deep/ .el-pager li.active + li {
    border-left: 0.0625rem solid #e5e5e5;
  }
  
  /deep/ .el-pager li {
    border: 0.0625rem solid #e5e5e5;
    font-weight: 400;
  }
  
  /deep/ .el-pagination span:not([class*='suffix']),
  .el-pagination button {
    height: 2rem;
    line-height: 2rem;
  }
  
  /deep/ .el-pagination__sizes {
    margin-left: 0.625rem;
  }
  
  /deep/ .el-pagination__jump {
    margin-left: 0.4375rem;
    margin-right: 0.9375rem;
  }
  /deep/ .el-pagination__sizes .el-input .el-input__inner:hover {
    font-style: normal;
    font-size: 0.875rem;
    text-align: left;
    border-color: rgba(24, 144, 255, 1);
  }
  </style>